const CANDIDATES = [',', ';', '\t', '|'] as const

function countUnquoted(line: string, delimiter: string): number {
    let count = 0
    let inQuotes = false
    for (const ch of line) {
        if (ch === '"') {
            inQuotes = !inQuotes
        } else if (!inQuotes && ch === delimiter) {
            count++
        }
    }
    return count
}

// Detects the most likely delimiter by combining mean field count and consistency
// across a small sample of lines. Higher mean and lower variance is preferred.
export function detectDelimiter(sampleLines: readonly string[]): string {
    const lines = sampleLines.slice(0, 20).filter((l) => l.length > 0)
    if (lines.length === 0) return ','

    let bestDelimiter: string = ','
    let bestScore = Number.NEGATIVE_INFINITY

    for (const delim of CANDIDATES) {
        const counts = lines.map((line) => countUnquoted(line, delim))
        const mean = counts.reduce((a, b) => a + b, 0) / counts.length
        if (mean < 1) continue

        const variance = counts.reduce((sum, c) => sum + (c - mean) ** 2, 0) / counts.length
        const score = mean - variance

        if (score > bestScore) {
            bestScore = score
            bestDelimiter = delim
        }
    }

    return bestDelimiter
}
